import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../footer";
import PageHeader from "../header";

const returnPolicy = () => {
    return (
        <>
            <div className="main-wrapper">
                <PageHeader />

                <div className="breadcrumb-bar">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="breadcrumb-list">
                                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/home">Home</Link>
                                            </li>
                                            <li className="breadcrumb-item">Pages</li>
                                            <li className="breadcrumb-item">Refund Policy</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <h1 className="mb-0">Refund Policy</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="terms-content">
                                    <div className="terms-text">
                                        <h3>
                                            Ultra Aura Education

                                        </h3>

                                        <p>
                                            At Ultra Aura Education, we are committed to providing high-quality educational experiences. We understand that sometimes plans change or unforeseen circumstances arise. Below is our refund policy to ensure clarity and transparency:

                                        </p>
                                        <h4> Refund Eligibility
                                        </h4>
                                        <ul>
                                            <li><h4>30-Day Satisfaction Guarantee:</h4> If you are not satisfied with your course or program within the first 30 days of enrollment, you are eligible for a full refund. To request a refund, you must contact us within 30 days of your purchase date.
                                            </li>
                                            <li> <h4>After 30 Days:</h4> Refunds are not available after the initial 30-day period. However, you may be eligible for partial refunds in specific circumstances, which will be reviewed on a case-by-case basis.

                                            </li>
                                        </ul>
                                        <h3> How to Request a Refund</h3>
                                        <p>
                                            <h4 >Submit a Request:</h4> To initiate a refund, please email our support team at info@ultraaura.education with your order number and reason for the refund.
                                            <h4>Processing Time:</h4> Refund requests will be processed within 7 business days of receipt. If your request is approved, the refund will be issued to the original method of payment.

                                        </p>
                                        <h3> Refund Conditions
                                        </h3>
                                        <p>
                                            <h4> Unopened Courses:</h4> Refunds are only available for courses or programs that have not been accessed or downloaded. If you have started the course, please refer to our 30-Day Satisfaction Guarantee policy.
                                            <h4>Technical Issues:</h4> If you experience technical issues that prevent you from accessing the course, please contact our support team immediately. We will work to resolve the issue or provide a suitable alternative.

                                        </p>
                                    </div>
                                    <div className="terms-text">
                                        <h3>Exceptions</h3>
                                        <p>
                                            <h4>Third-Party Courses:</h4> Refunds for courses provided by third-party vendors or partners are subject to their respective policies. We will assist you in contacting the third party to resolve any issues.
                                            <h4>Special Promotions:</h4> Courses purchased during special promotions or with discount codes may have different refund terms. Please refer to the specific terms provided at the time of purchase.

                                        </p>
                                        <h2> Contact Us </h2>
                                        <p>For any questions or concerns regarding our refund policy, please reach out to our customer support team at info@ultraaura.education or call us at 1803-967-7715
                                            Thank you for choosing Ultra Aura Education. We are dedicated to helping you achieve your educational goals and ensuring your satisfaction.
                                        </p>
                                        <div>
                                            <h2> Order Cancellation Policy
                                            </h2>
                                            <p className="fw-bold">At Ultra Aura Education, we are committed to providing a seamless and satisfactory experience for our customers. We understand that sometimes circumstances change, and you might need to cancel an order. Please review our order cancellation policy below:
                                            </p>
                                            <h4>Cancellation Window</h4>
                                            <ul>
                                                <li><h4>Digital Products:</h4>If you need to cancel an order for digital products (e.g., e-books, online courses, software), you may request a cancellation within 24 hours of purchase. Due to the immediate availability of digital content, cancellations made after this period are not eligible for a refund.</li>
                                                <li><h4>Physical Products:</h4> For physical products (e.g., printed materials, hardware), cancellations are accepted within 48 hours of the order being placed. Once the order has been processed and shipped, it cannot be canceled.
                                                </li>
                                            </ul>
                                            <h3>How to Cancel an Order
                                            </h3>
                                            <p>To cancel an order, please contact our Customer Support team through the following methods:
                                            </p>
                                            <p>Email: <a href="mailto:info@ultraaura.education">info@ultraaura.educcation</a>
                                            </p>
                                            <p>Phone: 1803-967-7715
                                            </p>
                                            <p>Online: Visit our Support Page and submit a cancellation request form.
                                            </p>
                                            <p>Please provide the following information in your cancellation request: <br />
                                                Order Number <br />
                                                Date of Purchase <br />
                                                Reason for Cancellation  <br />

                                            </p>
                                            <h3>Refunds
                                            </h3>
                                            <p>Digital Products: For eligible cancellations of digital products, a full refund will be issued to the original payment method within 5-7 business days.</p>
                                            <p>Physical Products: For eligible cancellations of physical products, refunds will be processed once the product has been returned and inspected. Please allow 7-10 business days for the refund to be processed after receiving the returned item.
                                            </p>
                                            <h3>Non-Refundable Items
                                            </h3>
                                            <p>Certain items are non-refundable, including:
                                            </p>
                                            <li>Customized or personalized products
                                            </li>
                                            <li>Subscription services already in use
                                            </li>
                                            <li>Any items purchased at a discounted or promotional rate</li>
                                            <h3>Exchange Policy</h3>
                                            <p>If you need to exchange a physical product instead of canceling it, please follow the steps outlined on our Returns and Exchanges page.
                                            </p>
                                            <h3>Contact Us</h3>
                                            <p>If you have any questions regarding this policy or need assistance with your order cancellation, please don’t hesitate to reach out to our Customer Support team. We are here to help and ensure your satisfaction.
                                            </p>
                                            <h4>Thank you for choosing Ultra Aura Education. We value your business and strive to provide the best possible service.
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default returnPolicy;
